// import bootstrap
import "bootstrap/dist/css/bootstrap.min.css";
import "aos/dist/aos.css";
import AOS from "aos";

export const onClientEntry = () => {
  AOS.init({
    once: true,
    duration: 800,
  });
};
